type ProductLike = {
  type: string;
  priceMode: string;
  variants?: Array<{ active?: boolean; unavailableBranchIds?: readonly string[] | Set<string> }>;
  ingredients?: Array<{ active?: boolean; selectable: boolean }>;
  optionGroups?: Array<{
    active?: boolean;
    options?: Array<{ active?: boolean; unavailableBranchIds?: readonly string[] | Set<string> }>;
  }>;
  groupAssignments?: Array<{
    group: {
      active?: boolean;
      options?: Array<{ active?: boolean; unavailableBranchIds?: readonly string[] | Set<string> }>;
    };
  }>;
};

function unavailableInBranch(unavailableBranchIds: readonly string[] | Set<string> | undefined, branchId: string): boolean {
  if (!branchId || !unavailableBranchIds) return false;
  return unavailableBranchIds instanceof Set
    ? unavailableBranchIds.has(branchId)
    : unavailableBranchIds.includes(branchId);
}

export function hasSelectableIngredients(product: Pick<ProductLike, 'ingredients'>): boolean {
  return (product.ingredients ?? []).some((ingredient) => ingredient.active !== false && ingredient.selectable === true);
}

export function hasActiveOptionGroups(product: Pick<ProductLike, 'optionGroups' | 'groupAssignments'>, branchId = ''): boolean {
  const groups = product.optionGroups ?? product.groupAssignments?.map((assignment) => assignment.group) ?? [];
  return groups.some((group) => (
    group.active !== false
    && (group.options ?? []).some((option) => (
      option.active !== false && !unavailableInBranch(option.unavailableBranchIds, branchId)
    ))
  ));
}

export function productRequiresVisualConfiguration(product: ProductLike, branchId = ''): boolean {
  return product.priceMode === 'variante'
    || (product.variants ?? []).some((variant) => variant.active !== false && !unavailableInBranch(variant.unavailableBranchIds, branchId))
    || product.type === 'combo'
    || hasActiveOptionGroups(product, branchId)
    || hasSelectableIngredients(product);
}
